import React from 'react'
import ReviewSwitch from './ReviewSwitch'
import { getLegacySubfieldReviewId, getReviewId } from '../utils/utils'
import { useReviewValues } from '../../../store'

const WrapWithReviewSwitch = ({
  children,
  field,
  review,
  comment,
  previousReviews,
  disabled,
  onReviewChange,
  fields,
  row,
}) => {
  const reviewValues = useReviewValues((state) => state.reviewValues)

  return (
    <div
      style={{
        display: 'flex',
        columnGap: 4,
        alignItems: 'center',
      }}
    >
      <div style={{ flexGrow: 1 }}>{children}</div>

      {(field.is_subfield ? getLegacySubfieldReviewId(field.id, row) : getReviewId(field.id)) in
      reviewValues ? (
        <div style={{ alignSelf: 'center' }}>
          <ReviewSwitch
            id={field.id}
            review={review}
            comment={comment}
            previousReviews={previousReviews}
            disabled={disabled}
            onReviewChange={onReviewChange}
            fields={fields}
            field={field}
            row={row}
          />
        </div>
      ) : null}
    </div>
  )
}

export default WrapWithReviewSwitch
